module.exports = __webpack_public_path__ + "static/media/tone2_bad.85d73775.svg";